/**
 * Each param contains 2 things:
 * identifier - the key which identifies the param
 * dataKey - one of the section's keys which should be used for this param
 */
export const PARAMS = {
    COUNTRY_FLAG: {
        identifier: 'country_flag_image',
        dataKey: 'country_code',
    },
    ICON_URGENT: {
        identifier: 'fit-icon_urgent',
    },
    ICON_ARROW: {
        right: 'fit-icon-l_arrow_right',
    },
    EYE: {
        identifier: 'eye_icon',
    },
    HEART: {
        identifier: 'heart_icon',
    },
    HISTORY_ICON: {
        identifier: 'history_icon',
    },
    BAG: {
        identifier: 'bag_icon',
    },
    COMPASS: {
        identifier: 'compass_icon',
    },
    BADGE_ICON: {
        identifier: 'badge_icon',
    },
    FREELANCER_ICON: {
        identifier: 'freelancer_icon',
    },
    SEARCH: {
        identifier: 'search_icon',
    },
    BRIEF: {
        identifier: 'brief_icon',
    },
    BRIEF_OR_SEARCH: {
        identifier: 'brief_or_search_icon',
    },
    SERVICE_ICON: {
        identifier: 'service_icon',
    },
    UGC_ICON: {
        identifier: 'ugc_icon',
    },
    WEBSITE_DEVELOPMENT_ICON: {
        identifier: 'website_development_icon',
    },
    VIDEO_EDITING_ICON: {
        identifier: 'video_editing_icon',
    },
    SOCIAL_MEDIA_MARKETING_ICON: {
        identifier: 'social_media_marketing_icon',
    },
    LATEST_BRIEF: {
        identifier: 'latest_brief',
    },
};

export const PARAMS_MATCHER = /(%{[a-zA-Z-_]+})/; // A param should be : %{param_identifier}
export const EXTRACT_PARAM_IDENTIFIER = /%{(.*)}/;
export const ICONS_SIZE = 24;
export const ARROW_ICONS_SIZE = 18;
export const SYSTEM_ICON_SIZE_LG = 'lg';
export const DYNAMIC_MATCHING_SOURCE = 'dynamic_matching';
